/* eslint-disable */
import type { SVGProps } from 'react';
import { memo } from 'react';

const HH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="500"
    height="250"
    xmlns="http://www.w3.org/2000/svg"
    id="Civil flag of Thuringia"
    viewBox="0 0 500 250"
    {...props}
  >
    <rect
      height="125"
      width="500"
      fill="#FFFFFF"
      x="0"
      y="0"
    />
    <rect
      height="125"
      width="500"
      fill="#E10000"
      x="0"
      y="125"
    />
  </svg>
);
export default memo(HH);
